module.exports = __webpack_public_path__ + "img/side-back-white.03272143.svg";